import type { MantineColor, MantineColorShade } from "@mantine/core";

import type { ChatTask } from "@/sdk/agent/chat";

export type ChatVariant =
    | "default"
    | "incoming"
    | "inactive"
    | "neglected"
    | "closedByCustomer"
    | "customerDisconnected"
    | "closedByExpert"
    | "transferredNeglected";

export const getChatVariant = (chatTask: ChatTask): ChatVariant => {
    // Only destructure properties needed for all paths - access specific getters lazily within branches
    const { status } = chatTask;

    switch (status) {
        case "pending":
            return "incoming";
        case "wrapping":
            // Only access these properties for wrapping chats
            return chatTask.isClosedByCustomer
                ? "closedByCustomer"
                : chatTask.wasCustomerDisconnected
                  ? "customerDisconnected"
                  : "closedByExpert";
        case "assigned":
        default: {
            if (chatTask.isNeglected) return "neglected";
            if (chatTask.isCustomerAbsent) return "inactive";
            if (chatTask.wasTaskNeglected) return "transferredNeglected";
            return "default";
        }
    }
};

export const getColorByVariant = (
    variant: ChatVariant,
): `var(--mantine-color-${MantineColor}-${MantineColorShade})` => {
    switch (variant) {
        case "neglected":
            return "var(--mantine-color-error-6)";
        case "inactive":
            return "var(--mantine-color-dark-2)";
        case "closedByCustomer":
        case "customerDisconnected":
        case "closedByExpert":
            return "var(--mantine-color-primary-2)";
        case "incoming":
        case "default":
        default:
            return "var(--mantine-color-dark-4)";
    }
};

export interface ChatVariantProps {
    variant: ChatVariant;
    variantColor: MantineColor;
}
